
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AIJobCreationTab } from "./AIJobCreationTab";
import { ManualJobCreationTab } from "./ManualJobCreationTab";
import { DocumentImportTab } from "./DocumentImportTab";

interface AIJobCreationDialogProps {
  open: boolean;
  onClose: () => void;
  clientId?: string;
  clientName?: string;
  onSuccess?: () => void;
}

export function AIJobCreationDialog({ 
  open, 
  onClose, 
  clientId, 
  clientName,
  onSuccess 
}: AIJobCreationDialogProps) {
  const [activeTab, setActiveTab] = useState("ai-creation");

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[900px] h-[90vh] flex flex-col p-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-4 border-b flex-shrink-0">
          <DialogTitle>Create your Job</DialogTitle>
          <p className="text-sm text-muted-foreground">
            Let AI help you create a compelling job posting that attracts top candidates
          </p>
        </DialogHeader>
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="flex-1 flex flex-col overflow-hidden">
          <div className="px-6 pt-4 flex-shrink-0">
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="ai-creation">AI Creation</TabsTrigger>
              <TabsTrigger value="manual">Manual Entry</TabsTrigger>
              <TabsTrigger value="document">Document Import</TabsTrigger>
            </TabsList>
          </div>

          <div className="flex-1 overflow-hidden">
            <TabsContent 
              value="ai-creation" 
              className="h-full overflow-y-auto px-6 pb-6 mt-0 focus-visible:outline-none"
            >
              <AIJobCreationTab 
                clientId={clientId}
                clientName={clientName}
                onSuccess={onSuccess}
                onClose={onClose}
              />
            </TabsContent>

            <TabsContent 
              value="manual" 
              className="h-full overflow-y-auto px-6 pb-6 mt-0 focus-visible:outline-none"
            >
              <ManualJobCreationTab 
                clientId={clientId}
                clientName={clientName}
                onSuccess={onSuccess}
                onClose={onClose}
              />
            </TabsContent>

            <TabsContent 
              value="document" 
              className="h-full overflow-y-auto px-6 pb-6 mt-0 focus-visible:outline-none"
            >
              <DocumentImportTab 
                clientId={clientId}
                clientName={clientName}
                onSuccess={onSuccess}
                onClose={onClose}
              />
            </TabsContent>
          </div>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
